import { MESSAGE, FILE_DOWNLOAD } from "../../constants/actionTypes";
import * as api from "../../api/index.js";

export const gumlet_movie_excel_sheet_detail =
  (formData) => async (dispatch) => {
    try {
      const { data } = await api.gumlet_movie_excel_sheet_detail(formData);
      dispatch({ type: MESSAGE, payload: data })
      return data;
    } catch (error) {
      console.log(error);
    }
  };
export const download_gumlet_video_file =
  (formData) => async (dispatch) => {
    try {
      const { data } = await api.download_gumlet_video_file(formData);
      dispatch({ type: FILE_DOWNLOAD, payload: data });
      return data;
    } catch (error) {
      console.log(error);
    }
  };
